import React, {useEffect, useState} from 'react';
import "./main.css"
import NavTab from "./component/NavTab";
import {useTranslation} from "react-i18next";
import OrderServicesTab from "./component/OrderServicesTab";
import ProvideServicesTab from "./component/ProvideServicesTab";
import {useDispatch} from "react-redux";
import {authLookupAC} from "../../redux/auth/auth-action";
import {authThunkUserAuthenticatedAndRedirect} from "../../redux/auth/auth-thunk";
import {LS_FIRM} from "../../consts/localStorageNaming";
import {TAB_HASH_IDS} from "../../routing_hash";
import {helpArticleGetByIdToggleModalThunk} from "../../redux/helpl-aricle/help-article-thunk";
import {HELP_ARTICLE_CONSTANTS_IDS} from "../../redux/helpl-aricle/help-article-constants";


export const CONST_TAB_SECTION_KEY = {
    order_service: "order_service",
    provider_service: 'provider_service'
}

export const TAB_SECTION = [
    {
        key: CONST_TAB_SECTION_KEY.order_service,
        lable: 'login_page.tab_order'
    },
    {
        key: CONST_TAB_SECTION_KEY.provider_service,
        lable: 'login_page.tab_provider'
    },

]
const LoginPlatform = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [tab, setTab] = useState(CONST_TAB_SECTION_KEY.order_service);
    const onSwitchTab  = (key)=>{
        setTab(key);
        dispatch(authLookupAC({isLoading: false, data: null, error: null, isError: false}))
    }
    useEffect(()=>{
        dispatch(authThunkUserAuthenticatedAndRedirect(localStorage.getItem(LS_FIRM), TAB_HASH_IDS.cabinet, null))
    }, []);
    const handlerHelpArticle = ()=>{
        dispatch(helpArticleGetByIdToggleModalThunk(HELP_ARTICLE_CONSTANTS_IDS.auth))
    }
    return (
        <section className={'section-login-platform'}>
            <div className="tab-root ">
                <div className="container">
                    <div className="row">
                        <NavTab t={t} onSwitchTab={(key) => setTab(key)} entry={TAB_SECTION} current={tab} handlerHelpArticle={handlerHelpArticle}/>
                    </div>
                </div>
            </div>
            <div className={'container'}>
                <div className="row">
                    {tab === CONST_TAB_SECTION_KEY.order_service && <OrderServicesTab/>}
                    {tab === CONST_TAB_SECTION_KEY.provider_service && <ProvideServicesTab/>}
                </div>
            </div>
        </section>

    );
};

export default LoginPlatform;